<template>
	<div
		ref="target"
		class="checkboxes-dropdown"
		:class="{
			'checkboxes-dropdown--expand': show_dropdown,
			'checkboxes-dropdown--stretch': stretch
		}"
	>
		<button
			class="checkboxes-dropdown__toggle"
			type="button"
			@click="show_dropdown = !show_dropdown"
		>
			<p class="checkboxes-dropdown__toggle-label">
				<span>
					{{ input_label }}
				</span>
			</p>
		</button>
		<div class="checkboxes-dropdown__content">
			<input
				v-if="!searchDisabled"
				:id="id"
				class="checkboxes-dropdown__search"
				type="text"
				:value="query"
				:placeholder="placeholder"
				@keyup.esc="show_dropdown = false"
				@input="handleSearch"
			>
			<ul class="checkboxes-dropdown__options-list">
				<PageLoaderComponent
					v-if="loading"
					:smaller="true"
				/>

				<template v-else>
					<li
						v-for="option in options"
						:key="`dropdown-option-${option.value}`"
					>
						<button
							class="checkboxes-dropdown__button"
							:class="( ( selected_client ) && ( option.value === selected_client.value ) ) ? 'checkboxes-dropdown__button--selected' : ''"
							:value="option.value"
							type="button"
							@click="e => handleSelection( e )"
						>
							{{ option.label }}
						</button>
					</li>
					<li v-if="!options || options.length === 0">
						No results
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../stores/new-project.js';
import { ref, watch, defineEmits, defineProps, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { onClickOutside } from '@vueuse/core';
import PageLoaderComponent from './PageLoaderComponent.vue';

const new_project_store = useNewProjectStore();

const {
	selected_client
} = storeToRefs( new_project_store );

const emit = defineEmits( ['update:query', 'search', 'select'] );

const props = defineProps( {
	id: {
		required: true,
		type: String
	},
	label: {
		required: true,
		type: String
	},
	placeholder: {
		required: false,
		type: String,
		default: 'Search'
	},
	query: {
		required: false,
		type: String,
		default: ''
	},
	options: {
		required: true,
		type: Array
	},
	stretch: {
		required: false,
		type: Boolean,
		default: false
	},
	searchDisabled: {
		required: false,
		type: Boolean,
		default: false
	},
	loading: {
		required: false,
		type: Boolean,
		default: false
	}
} );

const target = ref( null );
const show_dropdown = ref( false );
const input_label = ref( props.label );

onClickOutside( target, () => show_dropdown.value = false );

watch( show_dropdown, ( value ) => {
	if ( !value ) {
		emit( 'search', '' );
	}
} );

watch( selected_client, ( value ) => {
	if ( value ) {
		input_label.value = selected_client.value.label;
	}
} );

onMounted ( async() => {
	if ( selected_client && selected_client.value ) {
		input_label.value = selected_client.value.label;
	}
} );

const handleSelection = ( e ) => { // eslint-disable-line snakecasejs/snakecasejs
	show_dropdown.value = false;
	emit( 'select', e.target.value );
};

const handleSearch = ( e ) => { // eslint-disable-line snakecasejs/snakecasejs
	emit( 'update:query', e.target.value );
};
</script>
